import { ShieldCheckIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'react-i18next'

import { SurfaceCard } from '@/components/SurfaceCard'

export const NotFound = () => {
    const { t } = useTranslation()

    return (
        <div className="bg-account-page min-h-screen p-4 md:p-8">
            <div className="mx-auto max-w-3xl">
                <SurfaceCard title={t('states.notFoundTitle')} description={t('states.notFoundDescription')}>
                    <div className="text-account-secondary flex items-center gap-3 text-sm">
                        <ShieldCheckIcon className="h-5 w-5" />
                        404
                    </div>
                </SurfaceCard>
            </div>
        </div>
    )
}
